import React, { useCallback, useEffect, useMemo, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip, img, fmt, when } from "./kit";

/// Ayni telefondan acilmis hesaplar. Aralarindaki hediye hareketi gorunur;
/// biri digerine birlestirilebilir (coin, elmas, seviye, esya, VIP ana hesaba gecer).
// bizim (test/yonetim) hesaplarimiz: engellenemez, listede isaretli
const BIZIM = ["1000", "1001", "3085375"];

const bizimMi = (a) => BIZIM.includes(String(a.uniqueID));
// ana hesap onerisi: en cok satin alan, sonra en cok coin, sonra en son giren
const anaOner = (list) =>
  [...list].sort(
    (x, y) =>
      (y.purchasedCoin || 0) - (x.purchasedCoin || 0) ||
      (y.coin || 0) - (x.coin || 0) ||
      new Date(y.lastSeenAt || 0) - new Date(x.lastSeenAt || 0)
  )[0];
const SEKMELER = [
  ["bekleyen", "Bekleyen"],
  ["hediye", "Aralarında hediye"],
  ["cok", "3+ hesap"],
  ["bizim", "Bizim telefonlar"],
  ["kapali", "Çözülmüş"],
  ["hepsi", "Tümü"],
];

/// 3 Kas: birlestirme gecmisi + geri al
const Gecmis = () => {
  const [rows, setRows] = useState(null);
  const [ara, setAra] = useState("");
  const [busy, setBusy] = useState("");
  const load = useCallback(async () => {
    const r = await api.dupHistory();
    setRows(r?.status ? r.rows : []);
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const geriAl = async (r) => {
    const ok = window.confirm(
      `${r.from.name} (${r.from.uid}) → ${r.to.name || ""} (${r.to.uid}) birleştirmesi geri alınsın mı?\n\n` +
        (r.recorded
          ? `${r.from.uid} hesabı açılır; taşınan ${fmt(r.moved?.coin)} coin, ${fmt(r.moved?.diamond)} elmas, eşyalar, oda ve ajans geri döner (ana hesapta o kadar kalmadıysa kalan kadar).`
          : `${r.from.uid} hesabı açılır. Bu eski birleştirmede taşınan miktar kayıtlı değil; coin/elmas gerekiyorsa elle ayır.`)
    );
    if (!ok) return;
    setBusy(r.id);
    const x = await api.dupUndo(r.id);
    setBusy("");
    window.alert(x?.message || "Yapılamadı");
    load();
  };
  const q = ara.trim().toLowerCase();
  const list = (rows || []).filter((r) => !q || `${r.from.name} ${r.from.uid} ${r.to.name} ${r.to.uid}`.toLowerCase().includes(q));
  const kisi = (p) => (
    <div className="d-flex align-items-center" style={{ gap: 8, minWidth: 0 }}>
      <img src={img(p.image)} alt="" onError={(e) => (e.target.style.visibility = "hidden")} style={{ width: 30, height: 30, borderRadius: "50%", objectFit: "cover", background: "#E5E7EB", flex: "none" }} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#6B7280" }}>ID {p.uid}</div>
      </div>
    </div>
  );
  if (rows === null) return <div className="badu-empty">Yükleniyor…</div>;
  return (
    <>
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        <Chip>{rows.length} birleştirme</Chip>
        <Chip kind="warn">{rows.filter((r) => !r.recorded).length} eski (miktar kayıtsız)</Chip>
        <input className="form-control form-control-sm" style={{ maxWidth: 240, marginLeft: "auto" }} placeholder="Ad veya ID ara" value={ara} onChange={(e) => setAra(e.target.value)} />
      </div>
      <div className="card" style={{ margin: 0 }}>
        <div className="card-body" style={{ padding: 0, overflowX: "auto" }}>
          <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ color: "#6B7280", fontSize: 12, textAlign: "left" }}>
                <th style={{ padding: "8px 10px" }}>Tarih</th>
                <th style={{ padding: "8px 10px" }}>Kapatılan hesap</th>
                <th style={{ padding: "8px 10px" }} />
                <th style={{ padding: "8px 10px" }}>Ana hesap</th>
                <th style={{ padding: "8px 10px" }}>Taşınan</th>
                <th style={{ padding: "8px 10px" }} />
              </tr>
            </thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} style={{ borderTop: "1px solid #E5E7EB", opacity: r.undone ? 0.5 : 1 }}>
                  <td style={{ padding: "8px 10px", whiteSpace: "nowrap" }}>
                    {r.at ? when(r.at) : "—"}
                    {r.admin && <div style={{ fontSize: 11.5, color: "#6B7280" }}>{r.admin}</div>}
                  </td>
                  <td style={{ padding: "8px 10px", maxWidth: 220 }}>{kisi(r.from)}</td>
                  <td style={{ padding: "8px 4px", color: "#9CA3AF" }}>→</td>
                  <td style={{ padding: "8px 10px", maxWidth: 220 }}>{kisi(r.to)}</td>
                  <td style={{ padding: "8px 10px", fontSize: 12.5 }}>
                    {r.recorded ? (
                      <>
                        {fmt(r.moved?.coin)} coin · {fmt(r.moved?.diamond)} elmas
                        <div style={{ color: "#6B7280" }}>
                          {r.items || 0} eşya{r.rooms ? ` · ${r.rooms} oda` : ""}{r.agencies ? ` · ${r.agencies} ajans` : ""}
                        </div>
                      </>
                    ) : (
                      <span style={{ color: "#9CA3AF" }}>kayıtlı değil (eski)</span>
                    )}
                  </td>
                  <td style={{ padding: "8px 10px", textAlign: "right", whiteSpace: "nowrap" }}>
                    {r.undone ? (
                      <Chip kind="warn">Geri alındı</Chip>
                    ) : r.from.isBlock ? (
                      <button className="btn btn-sm btn-outline-danger" disabled={!!busy} onClick={() => geriAl(r)}>
                        {busy === r.id ? "…" : "Geri al"}
                      </button>
                    ) : (
                      <Chip>Hesap açık</Chip>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const Duplicates = () => {
  const [groups, setGroups] = useState(null);
  const [busy, setBusy] = useState("");
  const [sekme, setSekme] = useState("bekleyen");
  const [ara, setAra] = useState("");
  const [anaSecim, setAnaSecim] = useState({});
  // 2 Kas: telefon (cihaz) ya da IP (ayni internet) ile grupla
  const [by, setBy] = useState("device");

  const bilgi = useMemo(
    () =>
      (groups || [])
        .map((g) => {
          const acik = g.accounts.filter((a) => !a.isBlock);
          return {
            g,
            acik,
            bizim: g.accounts.some(bizimMi),
            anahtar: g.accounts.map((a) => a.id).sort().join("-"),
            arama: g.accounts.map((a) => `${a.name} ${a.uniqueID} ${a.email}`).join(" ").toLowerCase(),
          };
        })
        .sort(
          (a, b) =>
            b.g.internalGifts.coin - a.g.internalGifts.coin ||
            b.acik.length - a.acik.length
        ),
    [groups]
  );
  const uyar = useCallback((b, ad) => {
    if (ad === "hepsi") return true;
    if (ad === "bizim") return b.bizim;
    if (ad === "kapali") return b.acik.length < 2 && !b.bizim;
    if (b.bizim || b.acik.length < 2) return false;
    if (ad === "hediye") return b.g.internalGifts.count > 0;
    if (ad === "cok") return b.acik.length >= 3;
    return true;
  }, []);
  const q = ara.trim().toLowerCase();
  const gorunen = bilgi.filter((b) => uyar(b, sekme) && (!q || b.arama.includes(q)));

  const load = useCallback(async () => {
    if (by === "gecmis") return;
    setGroups(null);
    const r = await api.duplicates(by);
    setGroups(r?.status ? r.groups : []);
  }, [by]);
  useEffect(() => {
    load();
  }, [load]);

  const merge = async (keep, from) => {
    const ok = window.confirm(
      `${from.name} (${from.uniqueID}) hesabı ${keep.name} (${keep.uniqueID}) hesabına birleştirilsin mi?\n\n` +
        `Taşınacak: ${fmt(from.coin)} coin${from.diamond ? `, ${fmt(from.diamond)} elmas` : ""}, seviye puanları, mağaza eşyaları, VIP.\n` +
        `Odası ve ajans sahipliği de taşınır. ${from.uniqueID} hesabı kapatılır (silinmez).\nYanlışsa "Birleştirme geçmişi"nden geri alınabilir.`
    );
    if (!ok) return;
    setBusy(from.id);
    const r = await api.mergeAccounts(keep.id, from.id);
    setBusy("");
    window.alert(r?.message || (r?.status ? "Birleştirildi" : "Yapılamadı"));
    load();
  };

  const hepsiniBirlestir = async (keep, list) => {
    const ok = window.confirm(
      `Şu hesaplar ${keep.name} (${keep.uniqueID}) hesabına birleştirilsin mi?\n\n` +
        list.map((a) => `• ${a.name} (ID ${a.uniqueID}): ${fmt(a.coin)} coin, ${fmt(a.diamond)} elmas`).join("\n") +
        "\n\nSeviye puanları, mağaza eşyaları, VIP, oda ve ajans sahipliği de taşınır. Bu hesaplar kapatılır (silinmez). Yanlışsa \"Birleştirme geçmişi\"nden geri alınabilir."
    );
    if (!ok) return;
    setBusy("merge");
    const sonuc = [];
    for (const a of list) {
      const r = await api.mergeAccounts(keep.id, a.id);
      sonuc.push(`${a.uniqueID}: ${r?.message || (r?.status ? "Birleştirildi" : "Yapılamadı")}`);
    }
    setBusy("");
    window.alert(sonuc.join("\n"));
    load();
  };

  // cift hesap: hesabi ve TELEFONU engeller (o telefondaki tum hesaplar girisi kaybeder). IP engellenmez (ayni hat baskalarinda da olabilir).
  const ban = async (list, label) => {
    const ok = window.confirm(
      `${label} engellensin mi?\n\n` + list.map((a) => `• ${a.name} (ID ${a.uniqueID})`).join("\n") +
        "\n\nHesap kapanır ve bu telefon yasaklanır. IP yasaklanmaz. Kaldırmak için Yasaklar sayfası."
    );
    if (!ok) return;
    setBusy("ban");
    let n = 0;
    for (const a of list) {
      const r = await api.banUser({ userId: a.id, reason: "Çoklu hesap", banIp: false });
      if (r?.status) n++;
    }
    setBusy("");
    window.alert(`${n} hesap engellendi.`);
    load();
  };

  return (
    <>
      <PageHead
        title="Çift Hesaplar"
        sub={by === "ip" ? "Aynı IP adresinden (aynı ev / aynı internet) giren hesaplar. Dikkat: aynı evdeki farklı kişiler ya da mobil hatta aynı IP'yi paylaşanlar da çıkabilir; hediye hareketine bakarak karar ver." : "Aynı telefondan açılmış hesaplar. Hediye yapanlar en üstte. Ana hesabı seç, diğerlerini tek tuşla birleştir ya da engelle. Çoğu aynı kişinin bir kez Apple, bir kez Google ile girmesi."}
      />
      <div className="d-flex" style={{ gap: 6, marginBottom: 12 }}>
        {[["device", "Aynı telefon"], ["ip", "Aynı IP"], ["gecmis", "Birleştirme geçmişi"]].map(([k, y]) => (
          <button key={k} className={`btn btn-sm ${by === k ? "btn-dark" : "btn-outline-dark"}`} onClick={() => setBy(k)}>
            {y}
          </button>
        ))}
      </div>
      {by === "gecmis" ? (
        <Gecmis />
      ) : groups === null ? (
        <div className="badu-empty">Yükleniyor…</div>
      ) : (
        <>
          <div className="d-flex align-items-center" style={{ gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
            {SEKMELER.map(([ad, yazi]) => (
              <button key={ad} className={`btn btn-sm ${sekme === ad ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setSekme(ad)}>
                {yazi} ({bilgi.filter((b) => uyar(b, ad)).length})
              </button>
            ))}
            <input
              className="form-control form-control-sm"
              style={{ maxWidth: 240, marginLeft: "auto" }}
              placeholder="Ad, ID veya e-posta ara"
              value={ara}
              onChange={(e) => setAra(e.target.value)}
            />
          </div>
          {gorunen.length === 0 ? (
            <div className="badu-empty">Bu listede kayıt yok.</div>
          ) : (
            <div style={{ display: "grid", gap: 10 }}>
              {gorunen.map(({ g, acik, bizim, anahtar }) => {
                const ana = acik.find((a) => a.id === anaSecim[anahtar]) || anaOner(acik);
                const digerleri = acik.filter((a) => a.id !== ana?.id);
                const engellenebilir = digerleri.filter((a) => !bizimMi(a));
                return (
                  <div className="card" key={anahtar} style={{ margin: 0 }}>
                    <div className="card-body" style={{ padding: 12 }}>
                      <div className="d-flex align-items-center" style={{ gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
                        <b>{by === "ip" ? "IP" : "Telefon"} {g.device}</b>
                        <Chip kind={acik.length >= 3 ? "bad" : "warn"}>{acik.length} açık / {g.accounts.length} hesap</Chip>
                        {bizim && <Chip kind="ok">Bizim test telefonu</Chip>}
                        {g.internalGifts.count > 0 && <Chip kind="bad">Aralarında {g.internalGifts.count} hediye · {fmt(g.internalGifts.coin)} coin</Chip>}
                        {(g.warnings || []).map((w) => (
                          <Chip key={w} kind="warn">⚠ {w}</Chip>
                        ))}
                      </div>
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
                          <thead>
                            <tr style={{ color: "#6B7280", fontSize: 12, textAlign: "left" }}>
                              <th style={{ padding: "4px 8px" }}>Ana</th>
                              <th style={{ padding: "4px 8px" }}>Hesap</th>
                              <th style={{ padding: "4px 8px" }}>Coin</th>
                              <th style={{ padding: "4px 8px" }}>Elmas</th>
                              <th style={{ padding: "4px 8px" }}>Satın aldığı</th>
                              <th style={{ padding: "4px 8px" }}>Lv</th>
                              <th style={{ padding: "4px 8px" }}>Telefon / IP</th>
                              <th style={{ padding: "4px 8px" }}>Açılış</th>
                              <th style={{ padding: "4px 8px" }}>Son giriş</th>
                              <th style={{ padding: "4px 8px" }} />
                            </tr>
                          </thead>
                          <tbody>
                            {g.accounts.map((a) => (
                              <tr key={a.id} style={{ borderTop: "1px solid #E5E7EB", opacity: a.isBlock ? 0.55 : 1 }}>
                                <td style={{ padding: "6px 8px" }}>
                                  {!a.isBlock && acik.length > 1 && (
                                    <input
                                      type="radio"
                                      aria-label={`${a.name} ana hesap`}
                                      checked={ana?.id === a.id}
                                      onChange={() => setAnaSecim((s) => ({ ...s, [anahtar]: a.id }))}
                                    />
                                  )}
                                </td>
                                <td style={{ padding: "6px 8px", minWidth: 200 }}>
                                  <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                    <img src={img(a.image)} alt="" style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", background: "#E5E7EB" }} />
                                    <div>
                                      <div style={{ fontWeight: 700 }}>{a.name}</div>
                                      <div style={{ fontSize: 12, color: "#6B7280" }}>
                                        ID {a.uniqueID} · {a.login}{a.isHost ? " · Yayıncı" : ""}
                                      </div>
                                      {a.email && <div style={{ fontSize: 11.5, color: "#9CA3AF" }}>{a.email}</div>}
                                      {a.isBlock && <div style={{ fontSize: 12, color: "#B91C1C" }}>{a.blockReason || "Kapalı"}</div>}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ padding: "6px 8px" }}>{fmt(a.coin)}</td>
                                <td style={{ padding: "6px 8px" }}>{fmt(a.diamond)}</td>
                                <td style={{ padding: "6px 8px" }}>{fmt(a.purchasedCoin)}</td>
                                <td style={{ padding: "6px 8px" }}>{a.level}</td>
                                <td style={{ padding: "6px 8px", fontSize: 12, color: "#4B5563", whiteSpace: "nowrap" }}>
                                  {a.model || "—"}
                                  <div style={{ color: "#9CA3AF" }}>…{a.device} · {a.ip}</div>
                                </td>
                                <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>{a.createdAt ? when(a.createdAt) : "—"}</td>
                                <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>{a.lastSeenAt ? when(a.lastSeenAt) : "—"}</td>
                                <td style={{ padding: "6px 8px", textAlign: "right", whiteSpace: "nowrap" }}>
                                  {!a.isBlock && acik.length > 1 && a.id !== ana?.id && (
                                    <button className="btn btn-sm btn-outline-primary" style={{ marginRight: 4 }} disabled={!!busy} onClick={() => merge(ana, a)}>
                                      {busy === a.id ? "…" : "Birleştir"}
                                    </button>
                                  )}
                                  {!a.isBlock && !bizimMi(a) && (
                                    <button className="btn btn-sm btn-outline-danger" disabled={!!busy} onClick={() => ban([a], `${a.name} (ID ${a.uniqueID})`)}>
                                      Engelle
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {!bizim && digerleri.length > 0 && (
                        <div className="d-flex" style={{ gap: 6, flexWrap: "wrap", marginTop: 10 }}>
                          <button className="btn btn-sm btn-primary" disabled={!!busy} onClick={() => hepsiniBirlestir(ana, digerleri)}>
                            {busy === "merge" ? "…" : `Hepsini ${ana.uniqueID} hesabına birleştir (${digerleri.length})`}
                          </button>
                          {engellenebilir.length > 0 && (
                            <button className="btn btn-sm btn-danger" disabled={!!busy} onClick={() => ban(acik.filter((a) => !bizimMi(a)), "Bu telefondaki tüm açık hesaplar")}>
                              {busy === "ban" ? "…" : `Hepsini engelle (${acik.filter((a) => !bizimMi(a)).length} hesap + telefon)`}
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Duplicates;
